import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";

const qtySum = (o, f) => o.items.reduce((a, i) => a + (i[f] || 0), 0);

export const SupplierOpenOrders = ({ supplier, orders }) => (
  <div className="rounded-md border border-[#DCCFB8] bg-[#F5EFE4] p-3 text-sm" data-testid="sole-order-form-open-orders">
    <p className="font-semibold mb-1">{supplier} · açık siparişler</p>
    {orders.length === 0 ? <p className="text-xs text-[#8C7B68]">Bu firmada bekleyen sipariş yok.</p> : orders.map((o) => {
      const ord = qtySum(o, "qty"), got = qtySum(o, "received_qty");
      return (
        <p key={o.id} className="text-xs font-mono">
          #{o.no} · {new Date(o.created_at).toLocaleDateString("tr-TR")} · verilen {ord} · gelen <span className="text-[#047857]">{got}</span> · bekleyen <b className="text-[#B45309]">{ord - got}</b>
        </p>
      );
    })}
  </div>
);

export const DateNoteFields = ({ date, setDate, note, setNote }) => (
  <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
    <div>
      <Label className="text-xs text-[#6B5B4A]">İstenen Teslim Tarihi</Label>
      <Input data-testid="sole-order-form-date" type="date" value={date} onChange={(e) => setDate(e.target.value)}
        className="mt-1 h-11 bg-[#EFE6D6] border-[#DCCFB8]" />
    </div>
    <div>
      <Label className="text-xs text-[#6B5B4A]">Not</Label>
      <Input data-testid="sole-order-form-note" value={note} onChange={(e) => setNote(e.target.value)}
        className="mt-1 h-11 bg-[#EFE6D6] border-[#DCCFB8]" />
    </div>
  </div>
);
